import React, { useState } from 'react';
import {
  OutlinedInput,
  FormHelperText,
  FormControl,
  InputAdornment,
  Typography, SxProps
} from "@mui/material";
import { Theme } from "@mui/system";

interface NumericPriceInputProps {
  value: number | undefined;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  placeholder?: string;
  label?: string;
  errorText?: string;
  currencySymbol?: string; // <-- добавили
  sx?: SxProps<Theme>;
}

const NumericPriceInput: React.FC<NumericPriceInputProps> = ({
                                                               value,
                                                               onChange,
                                                               min = 0,
                                                               max = 999999,
                                                               placeholder = '',
                                                               label,
                                                               errorText = 'Недопустимое значение',
                                                               currencySymbol = '₽', // <-- по умолчанию
  sx,
                                                             }) => {
  const [isTouched, setIsTouched] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value.replace(/[^\d]/g, '');
    const parsed = rawValue === '' ? 0 : parseInt(rawValue, 10);

    onChange(parsed);
  };

  const isInvalid = value !== undefined && (value < min || value > max);

  return (
    <FormControl fullWidth variant="outlined" sx={{
      width: '100%',
      minHeight: '40px',
      borderRadius: '8px',
      background: 'var(--inputs-bg)',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 8px',
      gap: '8px',
      borderBottom: '2px solid transparent',
      transition: 'all 0.3s ease',
      position: 'relative',

      '& .MuiOutlinedInput-root': {
        width: '100%',
        fontSize: '16px',
        fontWeight: 400,
        caretColor: 'var(--secondary-text)',
        color: 'var(--secondary-text)',
        textTransform: 'none',
        transition: 'color 0.3s ease',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text !important',
        padding: 0,
        background: 'transparent',
      },

      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },

      '& .MuiInputAdornment-root': {
        color: 'var(--secondary-text)',
      },
    }} error={isInvalid && isTouched}>
      {label && <label style={{ marginBottom: 4 }}>{label}</label>}
      <OutlinedInput
        type="text"
        value={value}
        onChange={handleChange}
        onBlur={() => setIsTouched(true)}
        placeholder={placeholder}
        inputProps={{ inputMode: 'numeric' }}
        endAdornment={
          <InputAdornment position="end">
            <Typography color="text.secondary">{currencySymbol}</Typography>
          </InputAdornment>
        }
      />
      {isInvalid && isTouched && (
        <FormHelperText>{errorText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default NumericPriceInput;
